import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
const IStandaloneThemeService = ( createDecorator('themeService'));
export { IStandaloneThemeService };
